"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWarning = void 0;
var react_1 = require("react");
var styles_1 = require("../../styles");
function useWarning(condition) {
    var logArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        logArgs[_i - 1] = arguments[_i];
    }
    var logged = (0, react_1.useRef)(false);
    var logger = (0, styles_1.useCodeleapContext)().logger;
    if (!logged.current && condition) {
        logged.current = true;
        logger === null || logger === void 0 ? void 0 : logger.warn.apply(logger, __spreadArray([], __read(logArgs), false));
    }
}
exports.useWarning = useWarning;
